import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import logo from 'assets/img/oi_novoGuide.png';
// ANT COMPONENTS
import { Col, Row } from 'antd';
// CUSTOM COMPONENTS
import Banner from 'components/banner';
// HOOKS
import useDevice from 'hooks/useDevice';

const WaitingCall = ({ product }) => {

  const { mobile, desktop } = useDevice();

  return (
    <Col md={24}>
      <div className="vh-100 waiting-call-block">
        <Row type="flex">
          {desktop ?
            <div className="pt4 pl5">
              <img width="70.9" height="74.8" src={logo} alt="Oi Logo" />
            </div>
            : <Banner title={product.banner} />
          }
        </Row>
        <div className={classnames({ "pl5": desktop, "ph4": mobile })}>
          <Row type="flex">
            <div className="pt6">
              <span className="ttu waiting-call-title">
                Ok, Aguarde Nossa
                <br />
                Ligação
              </span>
            </div>
          </Row>
          <Row type="flex">
            <div className={classnames({ "pt5": desktop, "pt3": mobile })}>
              <span className="waiting-call-text">
                Ligaremos em instantes do número (61) 3213-2901
              </span>
            </div>
          </Row>
          <Row type="flex">
            <div className={classnames("absolute-ns", { "pt0 pb2 bottom-0": desktop, "pt3": mobile })}>
              <span className="waiting-call-subinfo">
                Enquanto isso, estamos levando você para a página inicial da Oi.
              </span>
            </div>
          </Row>
        </div>
      </div>
    </Col>

  );
};

WaitingCall.propTypes = {
  product: PropTypes.object
};

export default WaitingCall;
